import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import './styles/StudentsPage.css';
import { FaEye, FaEdit } from 'react-icons/fa';
import moment from 'moment';

const SavingsMonthlyReportPage = () => {
    const [savings, setSavings] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalData, setTotalData] = useState(0); 
    const [paymentDate, setPaymentDate] = useState('');
    const navigate = useNavigate();
    const [isSearched, setIsSearched] = useState(false);
    const itemCount = 50;

    useEffect(() => {
        if (isSearched) {
            handleSearch(); // Fetch students when currentPage changes
        }
    }, [currentPage, isSearched]);

    // Fetch students based on filter when search is clicked
    const handleSearch = async () => {
        try {
            const response = await api.post('/saving/report', {
                data: [{
                    date: paymentDate
                }],
                limit: itemCount, // Membatasi data per halaman menjadi 25
                page: currentPage // Mengirim halaman saat ini ke backend
            });
            setSavings(response.data.data.savingDetailList);
            setTotalData(response.data.data.totalCount); // Total data tanpa pagination
            setTotalPages(Math.ceil(response.data.data.totalCount / itemCount)); // Menghitung total halaman berdasarkan total data


            const totalCount = response.data.data.totalCount;
            
            if (totalCount > 0) {
                setTotalPages(Math.ceil(totalCount / itemCount));
                if(totalPages < currentPage){
                    setCurrentPage(1);
                }
            } else {
                setCurrentPage(1);
                setTotalPages(1);
            }

            setIsSearched(true);
        } catch (error) {
            console.error("Failed to fetch savings", error);
        }
    };
    
    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(prevPage => prevPage + 1);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(prevPage => prevPage - 1);
        }
    };

    const formatCurrency = (amount) => {
        return parseFloat(amount).toLocaleString('id-ID', { minimumFractionDigits: 0 });
    };


    return (
        <div className="students-page">
            <div className="page-title">Kidola Saving List</div>
            <div className="form-container">
                <div className="section">
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Transaction Month</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="month"
                                            name="paymentDate"
                                            value={paymentDate} 
                                            onChange={e => setPaymentDate(e.target.value)}
                                        />
                                    </td>  
                                </tr>
                                <tr>
                                    <td colSpan="2">
                                        <button onClick={handleSearch}>Search</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="section">
                    <div className="students-list">
                        <table>
                            <thead>
                                <tr>
                                    <th class="no-column">No</th>
                                    <th>Student Name</th>
                                    <th>Amount</th>
                                    <th>Transaction Date</th>
                                    <th>Transaction Type</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                {savings.map((saving, index) => (
                                    <tr key={saving.student_savings_detail_id}>
                                        <td class="no-column">{index + 1 + (currentPage - 1) * itemCount}</td>
                                        <td>{saving.StudentSaving.Student.student_name}</td>
                                        <td>{formatCurrency(saving.amount)}</td>
                                        <td>{moment(saving.transaction_date).format('DD MMMM YYYY')}</td>
                                        <td>{saving.transaction_type}</td>
                                        <td>{saving.description}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="total-data">
                        <span>Total Data: {totalData}</span>
                    </div>
                    <div className="pagination">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <button onClick={handlePrevPage} disabled={currentPage === 1}>
                                            Prev
                                        </button>
                                    </td>
                                    <td>
                                        <span>Page {currentPage} of {totalPages}</span>
                                    </td>
                                    <td>
                                        <button onClick={handleNextPage} disabled={currentPage === totalPages}>
                                            Next
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SavingsMonthlyReportPage;
